var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-full",
    viewBox: "0 0 29 28",
    fill: "#FF0000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1757 5.25H5.2075C3.99873 5.25 3.01886 6.22936 3.01886 7.4375V20.5625C3.01886 21.7706 3.99873 22.75 5.2075 22.75H24.1757C25.3845 22.75 26.3643 21.7706 26.3643 20.5625V7.4375C26.3643 6.22936 25.3845 5.25 24.1757 5.25ZM24.1757 7.4375V9.2971C23.1533 10.1292 21.5234 11.4231 18.039 14.1502C17.2711 14.7539 15.75 16.2042 14.6916 16.1873C13.6334 16.2044 12.1118 14.7536 11.3442 14.1502C7.86031 11.4235 6.23 10.1294 5.2075 9.2971V7.4375H24.1757ZM5.2075 20.5625V12.1041C6.2523 12.9358 7.73396 14.103 9.99232 15.8705C10.9889 16.6546 12.7342 18.3855 14.6916 18.375C16.6394 18.3855 18.3625 16.6797 19.3905 15.8709C21.6488 14.1034 23.1309 12.9359 24.1757 12.1041V20.5625H5.2075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.44e7c1db2ca3671fee4a441aedcf1333.svg";
export { ForwardRef as ReactComponent };